import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext({});

const DEFAULTS = {
  band_name: "The Randy Loveless Band",
  tagline: "Classic Rock · Montana · Since 2022",
  bio: "Formed by Randy Loveless from the Rockaholics in 2022. We play classic rock from the 60s-00's. Randy released his first CD (Trapped in a Montana Winter) in Nov. 2024. Randy has opened for Rick Derringer, Great White, Badfinger and ZZ Top.",
  booking_email: "booking@randylovelessband.com",
  phone: "(406) 555-ROCK",
  contact_1_label: "Randy Loveless",
  booking_email_2: "",
  phone_2: "",
  contact_2_label: "",
  location: "Kalispell, Montana",
  spotify_artist_url: "https://open.spotify.com/artist/7hHitkJMarKSdSUt028YQq",
  spotify_artist_id: "7hHitkJMarKSdSUt028YQq",
  facebook_url: "#",
  instagram_url: "#",
  youtube_url: "#",
  apple_music_url: "#",
  merch_visible: true,
  square_mode: "production",
  booking_blurb: "Private parties, festivals, fairs, weddings, concerts.",
  shows_note: "Catch us live. New dates announced monthly — sign up below to be the first to know.",
  music_note: "Randy's first studio record — recorded cold, played hot. Spin the live catalog below, then catch a show.",
  merch_note: "Sign up below for promo codes on launch day.",
  videos_visible: true,
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    axios
      .get(`${API_BASE}/settings`)
      .then((res) => setSettings({ ...DEFAULTS, ...res.data }))
      .catch(() => {});
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function useSiteSettings() {
  return useContext(SettingsContext);
}
